<div class="graph-container">
    <ngx-charts-heat-map [scheme]="colorScheme" [xAxis]="true" [yAxis]="true" [legend]="true" [results]="data">
    </ngx-charts-heat-map>
</div>